<template>
  <b-container>
    <h1>Test Site Check In</h1>

    <b-row>
        <b-col>
            <p class="error">{{ error }}</p>
        </b-col>
    </b-row>

    <b-row>
        <b-col cols="5">
            <b-input-group>
                <BaseTextInput v-model="shortCode" 
                                :v="$v.shortCode"
                                label="Enter or Scan Confirmation Code"
                                slug="shortCode"/>
                <b-input-group-append v-if="!submissionData.submissionId">
                    <b-button variant="primary" @click="onDataEntry"
                        style="height: fit-content; vertical-align: bottom; display: inline-block; margin-top: 2rem;">Submit</b-button>
                </b-input-group-append>
             </b-input-group>

             <div v-if="submissionData.submissionId">
                <b-input-group>
                   <BaseTextInput v-model="labId" 
                                :v="$v.labId"
                                label="Associated Lab Id"
                                slug="labId"/>
                    <b-input-group-append >
                        <b-button variant="primary" @click="onLabIdDataEntry"
                            style="height: fit-content; vertical-align: bottom; display: inline-block; margin-top: 2rem;">Submit</b-button>
                    </b-input-group-append>
                 </b-input-group>

                 <b-button @click="reset"
                            style="height: fit-content; vertical-align: bottom; display: inline-block; margin-top: 2rem;">Reset</b-button>
             </div>

        </b-col>
      <b-col cols="3">
        <qrcode-stream @decode="onDecode" @init="onInit" />
      </b-col>
    </b-row>

    <hr/>

    <b-row v-if="submissionData.code">
        <b-col cols="12">
            <SubmissionDetail :submission="submissionData"/>
        </b-col>
    </b-row>

    
  
</b-container>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
import SubmissionDetail from '@/components/SubmissionDetail'
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  });

export default {

  components: { 
    QrcodeStream,
    SubmissionDetail
   },

  data () {
    return {
      isLoading: false,
      shortCode: '',
      error: '',
      submissionData: {},
      labId: '',
      camera: 'auto'
    }
  },

  validations: {
    shortCode: { required },
    labId: { required }
  },

  methods: {
    onDecode (result) {
      this.shortCode = result
      this.turnCameraOff()
      this.loadSubmission()
      this.turnCameraOn()
    },

    loadSubmission() {
      this.isLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/registration/code/${this.shortCode}`)
        .then(response => {
            this.submissionData = response.data
            this.isLoading = false
        })
    },

    onLabIdDataEntry() {
        axios.put(`${process.env.VUE_APP_API_BASE_URL}/registration/lab/${this.submissionData.submissionId}/${this.labId}`)
        .then(response => {
            this.reset()
            this.showToast()          
        })
    },

    reset() {
        this.submissionData = {}
        this.labId = null
        this.shortCode = null
        this.$nextTick(() => { this.$v.$reset() })
    },

    onDataEntry() {
      this.loadSubmission()
    },

    turnCameraOn () {
      this.camera = 'auto'
    },

    turnCameraOff () {
      this.camera = 'off'
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permission"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },

    showToast() {
      this.$toast.success("Lab Id Saved.  Ready for Next Test.", {
        position: "top-center",
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: "button",
        icon: true,
        rtl: false
      });
    }
  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>